import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.5 11.25v2.25h-9v-2.25H3v2.25c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5v-2.25h-1.5zm-8.25-4.5l1.058 1.058L8.25 5.872V12h1.5V5.872l1.943 1.936L12.75 6.75 9 3 5.25 6.75z" fill="#4285F4" /></svg>);